import {Button, Form, Input} from 'antd';

export interface PrdispatchFormFields {
    authorEmail: string;
    prompt: string;
    newFeatureBranchName?: string;
}

interface Props {
    form: ReturnType<typeof Form.useForm<PrdispatchFormFields>>[0];
    onFinish: (values: PrdispatchFormFields) => void | Promise<void>;
    submitting: boolean;
    canSubmit: boolean;
}

export const PrdispatchDetailsFields = ({form, onFinish, submitting, canSubmit}: Props) => (
    <Form<PrdispatchFormFields>
        form={form}
        layout='vertical'
        onFinish={onFinish}
        autoComplete='off'
        disabled={submitting}
    >
        <Form.Item
            name='authorEmail'
            label='Project owner email'
            rules={[{required: true, message: 'Project owner email is required'}]}
        >
            <Input type='email'/>
        </Form.Item>
        <Form.Item
            name='prompt'
            label='Task prompt'
            rules={[{required: true, message: 'Task prompt is required'}]}
        >
            <Input.TextArea rows={8}/>
        </Form.Item>
        <Form.Item
            name='newFeatureBranchName'
            label='Feature branch name (optional)'
            help='lowercase, digits, ._/-; max 100 chars'
            normalize={(value?: string) => (value === '' ? undefined : value)}
        >
            <Input/>
        </Form.Item>
        <Form.Item>
            <Button type='primary' htmlType='submit' loading={submitting} disabled={!canSubmit}>
                Dispatch
            </Button>
        </Form.Item>
    </Form>
);
